import { WOW } from 'wowjs';

/**
 * 初始化滚动动画。
 * live:false 避免 webpack 打包后 this !== window 导致 MutationObserver 误判告警；
 * 内容已在 $nextTick 中渲染完成，再 sync 一次即可。
 */
export function initWow(custom = {}) {
    const oT = custom.offset != null ? custom.offset : $(window).height() * 0.1;
    let t = 0.1;
    let canReset = true;
    const wow = new WOW(
        Object.assign(
            {
                boxClass: 'wow',
                animateClass: 'animated',
                offset: oT,
                live: false,
                callback: function(el) {
                    $(el).css('animation-delay', t.toFixed(1) + 's');
                    t += 0.1;
                }
            },
            custom
        )
    );
    $(window).scroll(function() {
        if (canReset) {
            t = 0.2;
            setTimeout(function() {
                canReset = true;
            }, 150);
            canReset = false;
        }
    });
    wow.init();
    if (typeof wow.sync === 'function') {
        wow.sync();
    }
    return wow;
}
